import CrudAPI from '@/api/resources/crud'

const vendorsAPI = {
  // specific vendors api
  resource: 'vendors',

  getVendorItems (userId) {
    return new Promise((resolve, reject) => {
      let items = CrudAPI.dfsResourceIndex(this.resource + '/' + userId + '/items')

      items.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  }
}

export default vendorsAPI



// WEBPACK FOOTER //
// ./src/api/resources/vendors.js